import { Button, Row, Select, AutoComplete } from 'antd/lib'
import styled from 'styled-components'

const StyledButton = styled(Button)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: white;
  & p {
    width: 100%;
  }

  & > span > svg {
    color: white;
  }
`

const StyledRow = styled(Row)`
  display: flex;
  width: 100%;
  margin-top: 5px;
`
const StyledRowMobile = styled(Row)`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`

const StyledContainer = styled.div`
  padding: 0 10%;
`

const SearchContainer = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
  & > * {
    font-size: 14px;
    margin-bottom: 8px;
  }

  @media ${props => props.theme.xs} {
    width: 70%;
    & > * {
      font-size: 13px;
    }
  }

  @media ${props => props.theme.sm} {
    width: 60%;
  }
`

const StyledButtonContainer = styled.div`
  padding: 30px 15px;
`

const StyledSelect = styled(Select)`
  width: 100%;
`

const StyledTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10%;
  font-weight: bold;
  color: ${({ theme }) => theme.secondaryDarkGray};
`

const StyledAutocomplete = styled(AutoComplete)`
  width: 100%;
`
const StyledPrevStep = styled.div`
  width: 100%;
  margin: 15px 0;
`

const StyledPrevButton = styled(Button)`
  width: 100%;
  color: gray;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export {
  StyledButton,
  StyledRow,
  SearchContainer,
  StyledSelect,
  StyledTitle,
  StyledContainer,
  StyledRowMobile,
  StyledButtonContainer,
  StyledAutocomplete,
  StyledPrevStep,
  StyledPrevButton,
}
